// Func = limiting Scope for this file
var lastScrollTop = 0;
function scrollDown() {
	let top = $(document).scrollTop();
	if (top > ($('.banner').offset().top + $('.banner').height())) {
		$('.sub-menu').addClass('top-submenu');
	} else {
		$('.sub-menu').removeClass('top-submenu');
	}
}
(function(){

	$(document).ready(function () {
		// Main Nav Dropdown
		$("#primary-nav li").hover(function(){
			$(this).addClass("hover");
			$('ul.submenu',this).fadeIn(200);
		}, function(){
			$(this).removeClass("hover");
			$('ul.submenu',this).fadeOut(200);
		});

		$("#menu-btn, .close-menu ").on('click', function (e) {
			e.preventDefault();
			$(".header-menu").toggleClass("active");
		});
		$('.toggleBooking').on('click', function (e) {
			e.preventDefault();
			$(window).scrollTop(0);
			$(".container-booking, .option-booking .btn").toggleClass("active");
			$(".option-booking .btn").toggleClass("active");
		})
		$('.fb-iframe').fancybox({
			type : 'iframe'
		});
		//Properties Day's Calendar [Enable/Disable,ClassName,Tooltip]
		let DATE_STYLE = [true];
		function calendarRange(date){			
			let d1=$.datepicker.parseDate(DATE_FORMAT,$('#CheckIn').val());		
			let d2=$.datepicker.parseDate(DATE_FORMAT,$('#CheckOut').val());
			if (d1 && date.getTime() == d1.getTime() || d2 && date.getTime() == d2.getTime()) {
				DATE_STYLE[1] = 'highlight-top';
			}else if(date > d1 && date < d2){
				DATE_STYLE[1] = 'highlight';
			}else{
				DATE_STYLE[1] = '';
			}
			return DATE_STYLE;
		}

		// TOGGLE MAIN BOOKING
	document.querySelectorAll('.js-toggleBooking').forEach(btn => {
		btn.addEventListener('click', e => {
			e.preventDefault();

			// CLOSE MAIN NAV
			document.querySelectorAll('.js-toggleNav, .mainNav').forEach( m => m.classList.remove('active') );

			const bookingID = btn.getAttribute('href');
			if ( document.querySelector( bookingID ) ) {
				btn.classList.toggle('active');

				document.querySelector( bookingID ).classList.toggle('active');
				document.body.classList.toggle('noscroll', document.querySelector( bookingID ).classList.contains('active'));
			}
		});
	});

	// TOGGLE MAIN NAV
	document.querySelectorAll('.js-toggleNav').forEach(btn => {
		btn.addEventListener('click', e => {
			e.preventDefault();

			// CLOSE MAIN BOOKING
			document.querySelectorAll('.js-toggleBooking, .mainBooking').forEach( m => m.classList.remove('active') );

			const navID = btn.getAttribute('href');
			if ( document.querySelector( navID ) ) {
				btn.classList.toggle('active');

				document.querySelector( navID ).classList.toggle('active');
				document.body.classList.toggle('noscroll', document.querySelector( navID ).classList.contains('active'));
			}
		});
	});
		//$('body#map-category-sidebar #content').prepend('<a class="btn return-from-map" href="javascript:history.back()">« Back to previous page</a>');
		
	});

	window.onload = function() {
		/*this function add a class to header when scroll down the page
		/* and change the logo by a new file if needed depending of mockup
		*/

		// scrollDownAction(20, 'scroll');

		scrollW();
		window.addEventListener('scroll', function(){
			scrollW();
			scrollDown();
		})
	};

}());

function scrollW(){
	//check scroll down or up for header styles
	let st = window.pageYOffset || document.documentElement.scrollTop;
	if(st > 80){
		if (st > lastScrollTop){
			// downscroll code
			if(!document.getElementById('header').classList.contains('down')){
				document.getElementById('header').classList.add('down');
				document.getElementById('header').classList.remove('up');
			}
			if (document.getElementsByClassName('sub-menu').length > 0 &&  !document.getElementsByClassName('sub-menu')[0].classList.contains('down')) {
				document.getElementsByClassName('sub-menu')[0].classList.add('down');
				document.getElementsByClassName('sub-menu')[0].classList.remove('up');
			}
		} else {
			// upscroll code
			if(!document.getElementById('header').classList.contains('up')){
				document.getElementById('header').classList.add('up');
				document.getElementById('header').classList.remove('down');
			}
			if (document.getElementsByClassName('sub-menu').length > 0 && !document.getElementsByClassName('sub-menu')[0].classList.contains('up')) {
				document.getElementsByClassName('sub-menu')[0].classList.add('up');
				document.getElementsByClassName('sub-menu')[0].classList.remove('down');
			}
		}
	} else {
		if(document.getElementById('header').classList.contains('up') || document.getElementById('header').classList.contains('down')){
			document.getElementById('header').classList.remove('up');
			document.getElementById('header').classList.remove('down');
		}
		if (document.getElementsByClassName('sub-menu').length > 0 && (document.getElementsByClassName('sub-menu')[0].classList.contains('up') || document.getElementsByClassName('sub-menu')[0].classList.contains('down'))) {
			document.getElementsByClassName('sub-menu')[0].classList.remove('up');
			document.getElementsByClassName('sub-menu')[0].classList.remove('down');
		}
	}
	lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling
}